import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { Shield, ArrowRight } from "lucide-react";

const DirectLoginPage = () => {
  const navigate = useNavigate();
  const { adminLogin } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await adminLogin(password, "direct");
      toast.success("Admin access granted");
      // Use window.location for a full page navigation to ensure state is read from localStorage
      window.location.href = response.redirect || "/home";
    } catch (err) {
      toast.error("Invalid password");
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "#050505" }}
      data-testid="direct-login-page"
    >
      <Card className="w-full max-w-sm bg-[#0A0A0A] border border-[#7a6200]/30">
        <CardContent className="p-6">
          <div className="text-center mb-6">
            <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-[#7a6200]/20 flex items-center justify-center">
              <Shield className="w-7 h-7 text-[#7a6200]" />
            </div>
            <h1 className="font-bebas text-2xl tracking-wider text-white">
              ADMIN ACCESS
            </h1>
            <p className="text-[#52525B] text-sm font-ubuntu mt-1">
              Authorized personnel only
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="password"
              placeholder="Enter admin password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-dark h-12 text-center"
              data-testid="admin-password-input"
              autoFocus
            />

            <Button
              type="submit"
              className="btn-gold w-full h-12"
              disabled={loading || !password}
              data-testid="admin-login-submit"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <span className="flex items-center gap-2">
                  ACCESS <ArrowRight className="w-4 h-4" />
                </span>
              )}
            </Button>
          </form>

          <button 
            onClick={() => navigate("/login")}
            className="w-full mt-4 text-[#52525B] text-sm font-ubuntu hover:text-[#A1A1AA] transition-colors"
          >
            ← Back to Login
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default DirectLoginPage;
